import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LoadingSpinnerComponent } from '@app/shared/loading-spinner/loading-spinner.component';

@Component({
  selector: 'app-root-loading',
  imports: [LoadingSpinnerComponent],
  template: `
    <app-loading-spinner></app-loading-spinner>
  `,
  standalone: true
})
export class RootLoadingComponent implements OnInit {
  constructor(private router: Router) {}

  ngOnInit() {
    this.router.navigate(['/career-matches']);
  }
}
